/** 触发时机实验对照的三项：倒计时、下滑、离开动作。三项都开时反选会全部关掉，实验组没有对照。 */
const TRIGGER_KEYS = ["loadingCountDownShow", "loadingPageSlideShow"] as const;

function isOn(rules: Record<string, unknown>, key: string): boolean {
  const value = rules[key];
  return value === true || value === 1 || value === "true";
}

export function parseFormRules(settings: unknown): Record<string, unknown> | null {
  if (!settings) {
    return null;
  }
  let data: unknown = settings;
  if (typeof settings === "string") {
    try {
      data = JSON.parse(settings);
    } catch {
      return null;
    }
  }
  const rules = (data as { rules?: Record<string, unknown> })?.rules;
  return rules || null;
}

export function isAllTriggerConditionsSelected(rules: Record<string, unknown> | null): boolean {
  if (!rules) {
    return false;
  }
  const leaveOn = isOn(rules, "readyToLeave") || isOn(rules, "readyToLeaveBate");
  return TRIGGER_KEYS.every((key) => isOn(rules, key)) && leaveOn;
}

/** 去修改展示规则。弹窗规则在第二页，转盘规则在第三页。 */
export function formRulesEditPath(id: string, type?: number): string {
  if (Number(type) === 1) {
    return `/wheel_of_fortune/setting/${id}?tab=rules`;
  }
  return `/wheel_of_fortune/pop/${id}?tab=rules`;
}

